import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import TourContext from '../../context/TourContext';
import Route from '../common/Route'; // Import the existing Route component
import styles from './BottomNavBar.module.css';

const RouteScreen = () => {
  const { tourId, dateId } = useParams();
  const { selectedTour, selectedDate, setSelectedTour, setSelectedDate, tours } = useContext(TourContext);
  const navigate = useNavigate();
  
  // Ensure we have the correct tour and date selected
  React.useEffect(() => {
    if (tourId && dateId) {
      // If we have URL params, use those
      const tour = tours.find(t => t.id === tourId);
      if (tour && tour.id !== selectedTour?.id) {
        setSelectedTour(tour);
      }
      if (dateId !== selectedDate) {
        setSelectedDate(dateId);
      }
    } else if (!selectedTour || !selectedDate) {
      // If no tour or date is selected, redirect to dashboard
      navigate('/dashboard');
    }
  }, [tourId, dateId, tours, selectedTour, selectedDate, setSelectedTour, setSelectedDate, navigate]);

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div className={styles.datesModal}>
      <div className={styles.datesModalHeader}>
        <button className={styles.closeButton} onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2 className={styles.datesModalTitle}>Route</h2>
        <div style={{ width: '24px' }}></div> {/* Spacer for balance */}
      </div>
      
      <div style={{ 
        flex: 1, 
        padding: '1rem', 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden'
      }}>
        {/* We'll just embed the existing Route component */}
        <Route />
      </div>
    </div>
  );
};

export default RouteScreen;